<template>
	<div class="container page">
		<!-- 修改点 1: 标题显示，如果没有传参则显示“全部地区” -->
		<van-nav-bar :title="vod_name || '全部地区'" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="right">
			<van-pull-refresh pulling-text="새로고침 성공" loosing-text="페이지 새로 고침" loading-text="새로고침 성공"
				success-text="새로고침 성공" border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
				<van-grid :column-num="2" :gutter="10">
					<van-grid-item @click="profile(v.id)" v-for="(v, k) in datalist" :key="k">
						<van-image class="game_item_img" :src="v.img_url">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
						<span class="rig-name">{{ v.xuanfei_name }}</span>
					</van-grid-item>
				</van-grid>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			vod_name: '', // 默认为空
			isLoading: false,
			datalist: []
		};
	},
	methods: {
		back() {
			this.$router.push({ path: 'Choose' });
		},
		onRefresh() {
			// 刷新时重新获取全部列表
			this.getxuanfeilist();
		},
		profile(id) {
			// 修改点 2: 跳转详情页时，如果 query.id 不存在，传空或特定的标识
			const adsid = this.$route.query.id || '';
			this.$router.push({
				path: '/profile',
				query: {
					id: id,
					name: this.vod_name || '全部',
					adsid: adsid
				}
			});
		},
		getxuanfeilist() {
			// 修改点 3: 移除 data 中的 id 过滤条件，或根据是否有 id 来决定是否过滤
			const params = {};
			if (this.$route.query.id) {
				params.id = this.$route.query.id; // 如果有ID则按城市搜
			}
			// 如果后端支持不传 id 返回全部，则直接请求
			this.$http({
				method: 'get',
				url: 'xuanfeilist',
				params: params // 注意：GET请求通常使用 params 而不是 data，或者根据你框架封装来定
			}).then(res => {
				this.datalist = res.data;
				this.isLoading = false; // 关闭刷新状态
			}).catch(() => {
				this.isLoading = false;
			});
		}
	},
	created() {
		// 修改点 4: 兼容没有参数的情况
		this.vod_name = this.$route.query.name || '全部地区';
		this.getxuanfeilist();
	}
};
</script>

<style scoped>
/* 样式保持不变 */
.right {
	margin-top: 10px;
}

::v-deep .van-grid-item__content--center {
	border-radius: 15px;
	padding: 0;
	height: auto;
}

::v-deep .van-image__img {
	border-radius: 10px;
	padding: 15px;
}

.rig-name {
	width: 100%;
	height: 60px;
	line-height: 60px;
	margin-top: 10px;
	background-color: #f7f7f7;
	border-radius: 0 0 15px 15px;
	font-size: 15px;
	padding-left: 10px;
}
</style>